import { FormattedMessage, useIntl } from 'react-intl';

import { Input } from '@/components/ui/input';
import { Typography } from '@/components/ui/typography';
import { useJobPostingContext } from '@/contexts/job-posting-context';

interface PostingTitleProps {
  openingId: string;
}

export function PostingTitle({ openingId }: PostingTitleProps) {
  const intl = useIntl();
  const { hookForm } = useJobPostingContext();
  const {
    register,
    formState: { errors },
  } = hookForm;

  return (
    <div className="flex justify-between gap-6">
      <div className="flex w-full flex-col gap-1">
        <Typography variant="caption" className="!text-fx-neutral-500">
          <FormattedMessage
            defaultMessage="Title"
            description="Title of the job"
          />{' '}
          <span className="text-fx-rose">*</span>
        </Typography>
        <Input
          {...register(`jobDetails.${openingId}.title`)}
          placeholder={intl.formatMessage({
            defaultMessage: 'Enter title for the job',
            description: 'Placeholder for the title input for the job',
          })}
          error={errors?.jobDetails?.[openingId]?.title?.message}
        />
      </div>
    </div>
  );
}
